import request, { post, get } from '@/utils/request'
import { ouchnCustom } from '../../service'

const urlAddEvaluate = ouchnCustom + '/web/api/ocEvaluate/addEvaluate'
const urlDeleteEvaluate = ouchnCustom + '/web/api/ocEvaluate/del'
const urlGetEvaluateList = ouchnCustom + '/web/api/ocEvaluate/list'
const urlSelectEvaluate = ouchnCustom + '/web/api/ocEvaluate'
// const url = ouchnCustom + ''

// 为订单添加评论
export const apiAddEvaluate = (data) => post(urlAddEvaluate, data)

// 获取评价列表
export const apiGetEvaluateList = (params) => get(urlGetEvaluateList, params)

// 获取用户订单各状态下的total数
export const apiPathEvaluate = (params) => get(`${urlSelectEvaluate}/${params.id}`)

// 根据主键删除评价并修改商品评分
export const apiDeleteEvaluate = (params) => {
  return request({
    url: urlDeleteEvaluate,
    method: 'delete',
    params,
  })
}
